(function () {
  'use strict';

  const APPSTLE_BASE = '/apps/subscriptions/cp/api';

  function extractNumericId(gid) {
    if (typeof gid === 'number') return gid;
    const str = String(gid);
    const match = str.match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  }

  async function checkSubscription() {
    const banner = document.getElementById('active-subscription-banner');
    if (!banner) return;

    const productId = Number(banner.dataset.productId);
    if (!productId) return;

    try {
      const customerRes = await fetch(APPSTLE_BASE + '/logged-in-customer', {
        credentials: 'same-origin',
      });
      if (!customerRes.ok) return;

      const customerId = await customerRes.json();
      if (!customerId) {
        console.log('[SubscriptionChecker] No customer ID — user not logged in');
        return;
      }
      console.log('[SubscriptionChecker] Customer ID:', customerId);

      const contractsRes = await fetch(APPSTLE_BASE + '/subscription-customers-detail/valid/' + customerId, {
        credentials: 'same-origin',
      });
      if (!contractsRes.ok) {
        console.log('[SubscriptionChecker] subscription-customers-detail request failed:', contractsRes.status);
        return;
      }

      const contracts = await contractsRes.json();
      console.log('[SubscriptionChecker] Contracts response:', contracts);

      if (!Array.isArray(contracts)) {
        console.log('[SubscriptionChecker] Unexpected response format (not an array)');
        return;
      }

      const hasSubscription = contracts.some(function (contract) {
        if (!contract) return false;

        const status = String(contract.status || '').toUpperCase();
        if (status !== 'ACTIVE' && status !== 'PAUSED') return false;

        if (!contract.contractDetailsJSON) return false;

        let lines;
        try {
          lines = JSON.parse(contract.contractDetailsJSON);
        } catch (err) {
          console.log(
            '[SubscriptionChecker] Failed to parse contractDetailsJSON for contract',
            contract.id,
            err
          );
          return false;
        }

        if (!Array.isArray(lines)) return false;

        return lines.some(function (line) {
          return extractNumericId(line && line.productId) === productId;
        });
      });

      console.log('[SubscriptionChecker] Product ID:', productId, '| Match found:', hasSubscription);

      if (hasSubscription) {
        banner.classList.remove('hidden');
      }
    } catch (err) {
      console.log('[SubscriptionChecker] Error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkSubscription);
  } else {
    checkSubscription();
  }
})();
